export default __webpack_public_path__ + "static/media/level-4-bg.514bef07.png";